import React from 'react';
import styles from './style.module.css';

export default ({
    title = false,
    style = ''
}) => (
    <div className={style}>
        {
            title &&
            <p className={styles.title}>{title}</p>
        }
        <div className={styles.loadingContainer}>
            <div className={styles.circle1}/>
            <div className={styles.circle2}/>
            <div className={styles.circle3}/>
        </div>
    </div>
);
